import { render, staticRenderFns } from "./KimsaFilePicker.vue?vue&type=template&id=51d3b50f&scoped=true"
import script from "./KimsaFilePicker.vue?vue&type=script&lang=js"
export * from "./KimsaFilePicker.vue?vue&type=script&lang=js"
import style0 from "./KimsaFilePicker.vue?vue&type=style&index=0&id=51d3b50f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d3b50f",
  null
  
)

export default component.exports